"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clear = clear;
exports.clearAll = clearAll;
exports.humanize = humanize;
exports.isFedRAMP = isFedRAMP;
exports.load = load;
exports.publicPath = publicPath;
exports.save = save;
exports.toCapitalCase = toCapitalCase;
/* eslint-disable no-restricted-globals */
function isFedRAMP() {
  // FedRAMP is never valid
  return process.env.REACT_APP_FIPS_ENABLED === 'true';
}
function publicPath() {
  let _path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const path = _path.charAt(0) === '/' ? _path : '/' + _path;
  return "".concat(process.env.PUBLIC_URL).concat(path);
}
function humanize(bytes, onlyUnit) {
  const thresh = 1024;
  let newBytes = bytes;
  if (Math.abs(newBytes) < thresh) {
    if (onlyUnit) {
      return 'B';
    }
    return newBytes + ' B';
  }

  // these units normally denote base-1000 byte counting, but AWS
  // conventions are to use them for base-1024 byte counting
  const units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let u = -1;
  do {
    newBytes /= thresh;
    ++u;
  } while (Math.abs(newBytes) >= thresh && u < units.length - 1);
  if (onlyUnit) {
    return units[u];
  }
  return newBytes.toFixed(3) + ' ' + units[u];
}
function save(path, value) {
  try {
    const valueString = JSON.stringify(value);
    localStorage.setItem(path, valueString);
    return true;
  } catch (error) {
    return false;
  }
}
function load(path, defaultValue) {
  try {
    const valueString = localStorage.getItem(path);
    if (valueString === null) {
      return defaultValue;
    }
    return JSON.parse(valueString);
  } catch (error) {
    return defaultValue;
  }
}
function clear(path) {
  localStorage.removeItem(path);
}
function clearAll() {
  localStorage.clear();
}
function toCapitalCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}